export default __webpack_public_path__ + "static/media/windRose-white.ad0f5d54.svg";